import { CSSProperties } from 'react';

export interface BooleanDisplayProps {
  value: boolean;
  /** Custom labels for true/false states (defaults to 'Ja'/'Nein') */
  labels?: {
    true: string;
    false: string;
  };
  /** Custom colors for true/false states */
  colors?: {
    true: string;
    false: string;
  };
  /** Icon size (default: '1rem') */
  size?: string;
  /** Additional CSS class name */
  className?: string;
  /** Additional inline styles */
  style?: CSSProperties;
}

/**
 * Displays a boolean value as a professional icon suitable for administrative contexts.
 * - True values show a green circular checkmark
 * - False values show a neutral gray minus
 */
export function BooleanDisplay({
  value,
  labels = { true: 'Ja', false: 'Nein' },
  colors = { true: 'var(--green-700)', false: 'var(--surface-500)' },
  size = '1.25rem',
  className,
  style,
}: BooleanDisplayProps) {
  const label = value ? labels.true : labels.false;
  return (
    <i
      className={`${value ? 'pi pi-check-circle' : 'pi pi-minus'} ${className ?? ''}`}
      style={{
        color: value ? colors.true : colors.false,
        fontSize: value ? size : '0.5rem',
        ...style,
      }}
      aria-label={label}
      title={label}
      role="img"
    />
  );
}
